import styled from "styled-components";
import COLORS from '../../constants/colors';

export default styled.div`
    width: 228px;
    height: 50px;

    position: absolute;
    top: 19px;
    right: 19px;

    z-index: 99999999; //take priority over the survey's overlay

    display: flex;
    justify-content: space-evenly;
    align-items: center;

    background-color: #FFFFFF;
    border-radius: 4px;
    border: 1px solid ${COLORS.GREY_BORDER_HEADER};

    p {
        margin: 0; // override style from bootstrap (type.less)
    }
    
    [data-testid="Switch"] label{
        // override style .app label
        display: inline-flex;
        margin: 0; 
    }
`;